<div oui-dialog-title>
  {{ title }}
  <oui-button type="icon" oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
</div>
<oui-dialog-content [scroll]="isScrollable">
  <div class="flex-vertical gap-24" [class.extra-large]="!isScrollable" [class.thinner]="isScrollable">
    <ng-container *ngIf="!isLoading; else loading">
      <div class="flex-horizontal gap-48">
        <div
          class="flex-vertical gap-24 flex-1"
          *ngIf="leftColumnGroupedConfigs && hasAtLeastOneGamme(leftColumnGroupedConfigs) && !selectedType">
          <div
            *ngFor="let gamme of leftColumnGroupedConfigs | keyvalue | orderBy : 'key' : leftColumnOrder"
            class="flex-vertical gap-8">
            <div class="subtitle-1">{{ gamme.key }}</div>
            <div class="with-border rounded">
              <ng-container *ngFor="let type of gamme.value | keyvalue; let i = index; let last = last">
                <div
                  class="flex-center flex-horizontal padding-16 selectable cursor-pointer"
                  [class.with-border-bottom]="!last"
                  (click)="onTypeClick(type)">
                  <div>{{ type.key }}</div>
                  <div class="flex-1"></div>
                  <oui-icon>chevron_right</oui-icon>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div
          *ngIf="
            leftColumnGroupedConfigs &&
            hasAtLeastOneGamme(leftColumnGroupedConfigs) &&
            rightColumnGroupedConfigs &&
            hasAtLeastOneGamme(rightColumnGroupedConfigs) &&
            !selectedType
          "
          class="separator"></div>
        <div
          class="flex-vertical gap-24 flex-1"
          *ngIf="rightColumnGroupedConfigs && hasAtLeastOneGamme(rightColumnGroupedConfigs) && !selectedType">
          <div
            *ngFor="let gamme of rightColumnGroupedConfigs | keyvalue | orderBy : 'key' : rightColumnOrder"
            class="flex-vertical gap-8">
            <div class="subtitle-1">{{ gamme.key }}</div>
            <div class="with-border rounded">
              <ng-container *ngFor="let type of gamme.value | keyvalue; let i = index; let last = last">
                <div
                  class="flex-center flex-horizontal padding-16 selectable cursor-pointer"
                  [class.with-border-bottom]="!last"
                  (click)="onTypeClick(type)">
                  <div>{{ type.key }}</div>
                  <div class="flex-1"></div>
                  <oui-icon>chevron_right</oui-icon>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <div class="flex-vertical gap-8" *ngIf="backLabel">
        <div class="flex-horizontal flex-center">
          <oui-button type="icon" color="secondary" (click)="onBackClick()"><oui-icon>arrow_back</oui-icon></oui-button>
          <div>{{ backLabel }}</div>
        </div>
      </div>

      <div class="with-border rounded" *ngIf="selectedType && !configsByCategory">
        <ng-container *ngFor="let enveloppe of selectedType | keyvalue; let i = index; let last = last">
          <div
            class="flex-center flex-horizontal padding-16 selectable cursor-pointer"
            [class.with-border-bottom]="!last"
            (click)="onEnveloppeClick(enveloppe)">
            <div>{{ enveloppe.key }}</div>
            <div class="flex-1"></div>
            <oui-icon>chevron_right</oui-icon>
          </div>
        </ng-container>
      </div>

      <ng-container *ngIf="configsByCategory">
        <div
          *ngFor="let category of configsByCategory | keyvalue | orderBy : 'key' : categorieNatureOrder"
          class="flex-vertical gap-8">
          <div class="subtitle-1">{{ category.key }}</div>
          <div class="with-border rounded">
            <ng-container
              *ngFor="let config of category.value | orderBy : 'libelle' : null; let i = index; let last = last">
              <div class="flex-center flex-horizontal padding-16" [class.with-border-bottom]="!last">
                <div class="body-2">{{ config.libelle }}</div>
                <div class="flex-1"></div>
                <div>
                  <div class="flex-horizontal flex-center justify-center spinner">
                    <oui-loading *ngIf="config.id === isCreatingId" size="small" class="zoom"></oui-loading>
                  </div>
                  <oui-button
                    type="text"
                    (click)="onCreateFicheClick(config)"
                    iconSuffix="chevron_right"
                    *ngIf="config.configFormulaire && !(config.id === isCreatingId)"
                    >Créer la fiche conseil</oui-button
                  >
                  <oui-button
                    type="text"
                    (click)="onDownloadClick(config)"
                    iconPrefix="download"
                    *ngIf="config.legacyDocumentsDetails?.length > 0"
                    >Télécharger les documents</oui-button
                  >
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <oui-banner
          title="Les actes de gestion qui ne sont pas présents dans cette liste ne nécessitent pas de fiche conseil"
          [showCloseButton]="false"></oui-banner> </ng-container
    ></ng-container>
    <ng-template #loading>
      <div class="flex-horizontal width-100pc flex-center justify-center">
        <oui-loading *ngIf="isLoading"></oui-loading>
      </div>
    </ng-template>
  </div>
</oui-dialog-content>
